export default "__VITE_ASSET__BbfiT$e5__"